<template>
  <div class="cart__product product" v-if="$store.getters['auth/isRole']('ROLE_AGENT') == true">
    <router-link
      v-if="item.product.id"
      :to="{ name: 'ProductDetail', params: { id: item.product.id } }"
      class="product__image-container"
    >
      <img
        class="product__image"
        alt=""
        v-if="item.product.photos[0]"
        :src="imagesurl + '600/' + item.product.photos[0].name"
      />
      <img v-else class="product__image" src="/static/img/600x400.jpg" alt="" />
    </router-link>
    <div class="product__info-container">
      <div class="product__info-main">
        <div class="product__name-container">
          <h3 class="product__name">{{ item.product.label }}</h3>
        </div>
        <div class="product__price-container">
          <div v-for="productPrice in item.product.prices">
            <span class="product__price" v-if="productPrice.entreprise_description == 'MCI'"
              ><strong>{{ productPrice.price }}</strong> <sup><strong>€</strong> HT</sup></span
            >
          </div>
          <p class="product__price-text">Prix à l'unité</p>
        </div>
      </div>
      <p class="product__code">Code article : {{ item.product.code }}</p>
      <div class="product__imputation-container imputation">
        <!-- <span class="imputation__text">Code imputation :</span>
        <span class="imputation__selector">00000000</span> -->
      </div>
    </div>
    <div class="product__btns">
      <div class="product__quantity-container quantity">
        <span class="quantity__text">Quantité : </span>
        <span class="quantity__value">{{ item.quantity }}</span>
      </div>
      <router-link
        v-if="item.product.id"
        :to="{ name: 'ProductDetail', params: { id: item.product.id } }"
        class="product__btn product__btn--see"
      >
        <img src="/static/img/pictos/flecheblanche.svg" alt="" />
      </router-link>
    </div>
  </div>
  <div class="cart__product product product--mobile" v-else>
    <router-link
      v-if="item.product.id"
      :to="{ name: 'ProductDetail', params: { id: item.product.id } }"
      class="product__image-container"
    >
      <img
        class="product__image"
        alt=""
        v-if="item.product.photos[0]"
        :src="imagesurl + '600/' + item.product.photos[0].name"
      />
      <img v-else class="product__image" src="/static/img/600x400.jpg" alt="" />
    </router-link>
    <div class="product__info-container">
      <div class="product__info-main">
        <div class="product__name-container">
          <h3 class="product__name">{{ item.product.label }}</h3>
        </div>
        <div class="product__price-container" v-if="addable != false">
          <span class="product__price"
            ><strong>{{ item.product.price }}</strong> <sup><strong>€</strong> HT</sup></span
          >
          <p class="product__price-text">Prix à l'unité</p>
        </div>
      </div>
      <p class="product__code">Code article : {{ item.product.code }}</p>
      <!-- <div class="product__imputation-container imputation">
        <span class="imputation__text">Code imputation :</span>
        <span class="imputation__selector">{{ item.imputation.code }}</span>
      </div> -->
    </div>
    <div class="product__btns">
      <div class="product__quantity-container quantity">
        <span class="quantity__text" v-if="showQuantity == 'shipped'"
          >Quantité Cmd : {{ item.quantity }} - Exp : {{ item.shipped_quantity }}</span
        >
        <span class="quantity__text" v-else>Quantité : </span>
        <input
          type="text"
          class="quantity__value"
          name=""
          v-model="item.received_quantity"
          v-if="showQuantity == 'shipped'"
        />
        <span class="quantity__value" v-else>{{ item.quantity }}</span>
      </div>
      <router-link
        v-if="item.product.id"
        :to="{ name: 'ProductDetail', params: { id: item.product.id } }"
        class="product__btn product__btn--see"
      >
        <img src="/static/img/pictos/flecheblanche.svg" alt="" />
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProductOrder",
  props: ["item", "addable", "showQuantity"],
  data() {
    return {};
  },
  computed: {
    imagesurl() {
      return process.env.BACK_UPLOADS_URL;
    },
    me: function () {
      let me = this.$store.getters["auth/user"];

      if (typeof me == "string") {
        return JSON.parse(me);
      } else {
        return me;
      }
    },
  },
  mounted() {},
};
</script>


<style lang="scss" scoped>
@import "~@/assets/scss/_colors.scss";

.product {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  position: relative;
  padding-top: 15px;
  background-color: white;
  width: 100%;
  height: auto;
  border-bottom: 1px solid $grisclair;
  &__image-container {
    width: 100px;
    height: 100%;
  }
  &__image {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  &__info-container {
    flex: 1;
    height: 100%;
    padding: 0 10px;
  }
  &__info-main {
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    width: 100%;
    align-items: top;
    .product__name-container {
      flex: 1;
      line-height: 1;
    }
    .product__price-container {
      width: 110px;
      text-align: left;
      line-height: 1;
      padding-left: 20px;
    }
  }
  .quantity {
    flex: 1;
    &__text {
      color: $grisfonce;
      font-family: "ClanPro";
      text-transform: uppercase;
      font-size: 12px;
      margin-left: 20px;
    }
    &__value {
      width: 55px;
      height: 55px;
      border-radius: 50%;
      background-color: $grisclair;
      display: inline-block;
      line-height: 55px;
      text-align: center;
      border: none;
      margin-bottom: 15px;
      outline: none;
      margin-left: 5%;
      font-family: "ClanFFBlack";
      font-weight: normal;
      color: $color1;
    }
  }
  .imputation,
  .tech {
    &__text {
      font-size: 12px;
      color: $grisfonce;
      font-family: "ClanPro";
      width: 105px;
      display: inline-block;
      text-align: right;
    }
    &__selector {
      font-size: 12px;
      color: $grisfonce;
      font-family: "ClanPro";
      padding: 5px 10px;
      border: 1px solid $grisclair;
      width: auto;
      display: inline-block;
    }
  }
  .technicien {
    margin-top: 10px;
  }
  &__name {
    font-size: 15px;
    text-transform: uppercase;
    font-family: "ClanFFBlack";
    color: $mystockblue;
  }
  &__price {
    font-size: 25px;
    color: $color2;
    white-space: nowrap;
    strong {
      font-family: "ClanFFBlack";
      font-weight: normal;
    }
    sup {
      font-size: 10px;
      font-family: "ClanPro";
    }
  }
  &__price-text {
    font-size: 10px;
    font-family: "ClanPro";
    color: $color2;
  }
  &__code {
    font-size: 12px;
    color: $grisfonce;
    font-family: "ClanPro";
  }
  &__btns {
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    align-items: flex-end;
    margin-top: 20px;
    width: 100%;
  }
  &__btn {
    width: 80px;
    text-align: center;
    height: 40px;
    color: white;
    line-height: 36px;
    &--see {
      background-color: $color2;
    }
    &--add {
      background-color: $color3;
    }
    img {
      width: 16px;
    }
    &--delete {
      background-color: $color1;
      img {
        width: 12px;
      }
    }
  }
  &--in-content {
    padding-top: 0;
    min-width: 405px;
    .product__image-container {
      width: 40%;
      height: auto;
    }
    .product__info-container {
      width: 60%;
      flex: auto;
      height: auto;
      padding-top: 10px;
    }
  }
  &--mobile {
    min-width: 320px;
    .product__image-container {
      width: 40%;
      height: 120px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Product/ProductOrder.vue